export default __webpack_public_path__ + "static/media/README.16b9e364.md";